module.exports = __webpack_public_path__ + "img/logo-netl_white.c9528e18.png";